export const getAllDesignation = () => ({
    url: `admin/designation`,
    method: 'GET'
})

export const addDesignation = (data) => ({
    url: `admin/designation`,
    method: 'POST',
    body: { ...data }
})

export const editDesignation = ({ data, id }) => ({
    url: `admin/designation/${id}`,
    method: 'PUT',
    body: { ...data },
})

export const getSingleDesignation = (id) => ({
    url: `admin/designation/${id}`,
    method: 'GET'
})

export const deleteDesignation = (id) => ({
    url: `admin/designation/${id}`,
    method: 'DELETE'
})